module.exports = __webpack_public_path__ + "img/i-filter-black.ec72764f.svg";